import React, { ReactElement, useState, useEffect } from 'react';
import { AxiosResponse } from 'axios';

import { createUrl, request } from 'app/utils';

import { Flex, Section, Loading, Page } from 'components';
import { useTeachers, TeachersApiResponse, TeachersList } from 'features/teachers';
import { useSchool } from 'features/school';
import { useMenu } from 'features/menu';
import { useNavigate } from 'react-router-dom';
import { useResources } from 'features/resources';

const TeachersListView = (): ReactElement => {
  const [loading, setLoading] = useState(true);

  const { apiGatewayUrl, schoolUuid } = useSchool();
  const { teachers, setTeachers, clearTeachers } = useTeachers();
  const { setBackPathname } = useMenu();
  const { usingTeachers } = useResources();

  const navigate = useNavigate();

  const fetch = async () => {
    await Promise.all([
      request({
        url: '/api/v1/School/Teachers',
        method: 'get',
        baseURL: apiGatewayUrl,
      }).then((response: AxiosResponse<TeachersApiResponse>) => {
        setTeachers(response.data);
      }),
    ]).then(() => {
      setLoading(false);
    });
  };

  useEffect(() => {
    fetch();

    setBackPathname(createUrl('dashboard'));

    return () => {
      clearTeachers();

      setBackPathname(createUrl('teachersList'));
    };
  }, []);

  useEffect(() => {
    if (schoolUuid !== '85338cb1-8075-4dcf-afe2-6ce534dcde27') {
      navigate(createUrl('dashboard'));
    }
  }, [schoolUuid]);

  if (loading) return <Loading label="Por favor, aguarde." />;

  return usingTeachers ? (
    <Page title="Todos os cursos">
      <Flex py={{ m: 30, t: 60, d: 90 }} bg="gray_200" flexGrow={0}>
        <Section flexDirection="column">
          <TeachersList teachers={teachers} />
        </Section>
      </Flex>
    </Page>
  ) : (
    <></>
  );
};

export default TeachersListView;
